import { useState } from "react";
import MobileDestinationChips from "../components/MobileDestinationChips";
import MobilePropertyCard from "../components/MobilePropertyCard";
import MobileSearchCard from "../components/MobileSearchCard";
import MobileLayout from "../layouts/MobileLayout";
import useMobileProperties from "../hooks/useMobileProperties";

export default function MobileSearch() {
  const [query, setQuery] = useState("");
  const { items } = useMobileProperties({ search: query });

  return (
    <MobileLayout>
      <section className="hv-section" style={{ marginTop: 0 }}>
        <h1 className="hv-section-title">Search</h1>
        <div className="hv-field" style={{ marginTop: 12 }}>
          <label htmlFor="mobile-search-input">Where are you going?</label>
          <input id="mobile-search-input" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search destination or villa" />
        </div>
      </section>
      <MobileSearchCard compact />
      <section className="hv-section">
        <div className="hv-section-head"><h2 className="hv-section-title">Popular destinations</h2></div>
        <MobileDestinationChips />
      </section>
      <section className="hv-section">
        <div className="hv-section-head"><h2 className="hv-section-title">Results</h2></div>
        <div className="hv-list-stack">
          {items.slice(0, 6).map((property) => <MobilePropertyCard key={property.id} property={property} />)}
        </div>
      </section>
    </MobileLayout>
  );
}

